export default `
	workday_day
    workday_start
    workday_end
`;
